import LoginForm from "./LoginForm";
import { Link } from 'react-router-dom';
import "./LoginView.css";

export default function LoginView() {
    return <div className="popup loginView">
        <div className="title"><img alt="Kingds and Emperors" src="logo.png"/> Kings and Emperors</div>
        <div className="separator"/>
        <div className='content'>
            <LoginForm/>
            <div className="registerLink">
                Or <Link to="/">click here to register</Link>
            </div>
        </div>
    </div>
};